<template>
  <template v-if="dType === 'detail_radar'">
    <!-- <div class="detailData">
      스포츠 베팅내역
    </div> -->
    <iframe
    title="Inline Frame Example"
    width="1000"
    height="530"
    :src="detailData.dLink"></iframe>
  </template>

  <template v-if="dType === 'detail_2'">
    <!-- <div class="detailData">
      스포츠 베팅내역
    </div> -->
    <iframe
    title="Inline Frame Example"
    width="1000"
    height="530"
    :src="detailData.url"></iframe>
  </template>

  <template v-else>
    <template v-for="item in detailData.list" :key="item.id">
      <div class="detailData">
        {{ item }}
      </div>
    </template>
  </template>
</template>

<script>
export default {
  name: 'vendorCodeEtc',
  props: ['detailData', 'dType']
}
</script>

<style scoped></style>
<script setup></script>
